/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { type AnalyticsParams, type AnalyticsReport, analyticsApi } from '../api/analytics.js';

export function useAnalyticsReport(params: AnalyticsParams): UseQueryResult<AnalyticsReport> {
  return useQuery({
    queryKey: ['analytics', 'report', params],
    queryFn: () => analyticsApi.report(params),
  });
}
